export const meta = {
  title: '服务条款 | Hotel Lobby AI',
  description:
    'Hotel Lobby AI 站内双人 AI 对唱视频生成服务的使用条款：积分、计费、退款、可接受使用与账号处置。',
  updated_at: '2026-10-03',
};

## 使用 Hotel Lobby AI

Hotel Lobby AI（以下简称"我们"）运营 hotel-lobby.org，这是一项将两张照片生成双人 AI 对唱短视频的在线服务。创建账户、购买积分或以其他方式使用本网站，即表示您同意本条款及构成本条款组成部分的[《可接受使用政策》](/zh/acceptable-use-policy)。如不同意，请勿使用本服务。您须年满 18 周岁（或所在地的法定成年年龄）方可创建账户或进行购买。

## 服务内容

所有生成均在 Hotel Lobby AI 站内完成。您为两个人各上传一张照片，并可选填一段简短的风格说明。随后我们会：

1. **生成场景和视频。** 您的照片和说明会发送给我们的 AI 处理服务商，合成两人站在橙色录音棚里的场景并生成完整对唱视频。每次生成都会消耗积分，开始前会显示所需数量。
2. **生成视频。** 如您选择继续，我们会把对唱表演和音频迁移到该场景上，通常在 3–5 分钟内交付一段 MP4 视频。每个视频消耗积分，开始前按钮上会显示具体数量。

生成好的视频保存在您账户的 **我的视频** 中。AI 生成结果存在不确定性，分享前请检查人物身份、面部、手部和位置。我们不保证生成结果一定符合您的预期。

## 账户

请妥善保管登录信息，如怀疑账户被他人使用，请及时联系 [support@hotel-lobby.org](mailto:support@hotel-lobby.org)。您对账户下的所有活动负责。同一人不得注册多个账户以获取额外的注册积分或促销福利。

## 积分、计费与支付

- **积分。** 生成视频会从您的余额中扣除积分。积分不具有现金价值，不可转让或兑换现金，仅限在 Hotel Lobby AI 使用。账户存续期间，购买的积分不会过期。
- **一次性积分包。** 一次付款获得固定数量的积分。
- **订阅。** 月付方案按结账时显示的价格自动续费，每个计费周期发放该方案的积分，直至您取消。
- **赠送积分。** 注册赠送、首单加送等促销积分为免费赠送，可能附带额外条件，一律不予退款。
- **价格与税费。** 购买前会显示价格。付款由第三方支付服务商或记录商户（Merchant of Record）处理，交易同时适用其条款。结账时可能会加收适用税费。

## 退款与取消

- **生成失败。** 如因技术原因生成失败，所消耗的积分会自动退回您的余额，无需申请。
- **一次性积分包。** 购买后 **60 天** 内，且该积分包的积分 **一点都未使用**，可申请全额退款。该积分包的积分一旦使用，此笔购买即不予退款。
- **订阅。** 您可随时在 **设置 → 账单** 中取消。取消后不再自动续费，当前计费周期结束前，方案和剩余积分仍可继续使用。未满一个计费周期的部分不退款，也不按比例折算。续费扣款后 **60 天** 内，且未使用该次续费发放的任何积分，可申请退还该次续费。
- **如何申请退款。** 请用账户邮箱发送邮件至 [support@hotel-lobby.org](mailto:support@hotel-lobby.org)，并附上订单号。退款批准后原路退回，该笔购买对应的积分将从余额中扣除。
- **例外。** 因违反本条款或《可接受使用政策》而被暂停或终止的账户，其购买不予退款。本节内容不影响您依据适用的消费者保护法律享有的退款权利。

## 您的内容

请仅在您拥有相关权利、并已获得照片中每个人许可的情况下上传照片。您保留对自己照片原有的权利。您授予我们有限的许可，仅为向您提供服务而存储和处理您的照片、说明和生成的视频，包括将其发送给我们的 AI 处理和存储服务商。您对提交的内容以及如何使用、分享生成的视频负责。分享时请标明内容由 AI 生成。

## 可接受使用

您必须遵守[《可接受使用政策》](/zh/acceptable-use-policy)。简言之：禁止任何涉及性化或剥削未成年人的内容，禁止任何形式的色情或私密内容，禁止制作未经本人同意的深度伪造内容，禁止冒充他人、骚扰或违法内容，禁止试图绕过我们的安全机制。我们会在生成前审核风格说明，并有权拒绝任何请求。

## 违规与账号处置

如我们有合理理由认为您违反了本条款或《可接受使用政策》，我们可根据违规的严重程度采取以下措施：

- 拒绝或取消生成，并删除相关内容；
- 发出警告；
- 暂时停用您的账户或其生成功能；
- 永久终止您的账户，并封禁为规避处罚而新注册的账户；
- 对严重或屡次违规的账户，扣除或作废剩余积分，且不予退款；
- 在法律要求或适当时，向执法部门或儿童保护机构报告相关内容和账户信息。

涉及性剥削未成年人的内容，将立即永久终止账户并向相关部门报告。因违规被拒绝或删除的内容所消耗的积分不予退回。对您的付款发起拒付（chargeback）或撤销付款，可能导致账户在问题解决前被暂停。如您认为我们处理有误，请在 30 天内发送邮件至 [support@hotel-lobby.org](mailto:support@hotel-lobby.org)，我们会重新审核。

## 免责声明与责任限制

本服务按"现状"和"现有可用"状态提供。在法律允许的范围内，我们不作任何默示保证，包括对特定用途适用性的保证。在法律允许的范围内，我们就本服务相关的任何索赔所承担的全部责任，以索赔发生前 12 个月内您向我们支付的金额为限。我们不对间接或后果性损失负责。部分司法辖区不允许此类限制，因此上述限制可能不适用于您。

## 变更与可用性

我们可能更改、暂停或终止部分服务，也可能更新本条款，修订日期见页首。重大变更自发布之日起生效，此后继续使用即表示您接受变更。

## 联系我们

关于本条款、计费或退款的问题：[support@hotel-lobby.org](mailto:support@hotel-lobby.org)。举报违规内容，请参阅[《可接受使用政策》](/zh/acceptable-use-policy)中的"举报违规内容"一节。
